<template>
    <div class="dashboard-promo-banner-delete" :class="{ open: isOpen }">
      <div class="banner--content">
        <div class="banner-content-wrap">
          <div class="banner--content__left">
            <div class="promo">
              <div class="promo-intro">
                <span v-if="!deleteErrorMessage" v-translate>Account Marked for Deletion</span>
                <span v-if="deleteErrorMessage" v-translate>Error deleting account</span>
              </div>
                <span v-if="!deleteErrorMessage" @click="cancelDeleteProfile()" class="cancel-deletion-message">
                    {{ $gettext('This account is marked for deletion. Please click here in order to cancel the deletion process.') }}
                </span>
                <span v-if="deleteErrorMessage">{{ deleteErrorMessage }}</span>
            </div>
          </div>
          <div v-if="currentUser.profile && currentUser.profile.deletion_procedure" class="banner--content__right">
            <div class="flip-count">
              <span class="flip-title">{{ $gettext('The account will be deleted at:') }}</span>
              <FlipCount :time-until="currentUser.profile.deletion_procedure" />
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
  
  <script>
    import { mapGetters } from "vuex";
    import FlipCount from "@/components/dashboard/ui/FlipCount"
    import DashboardService from "@/store/services/dashboard.service"

    export default {
        name: "DeleteAccountBanner",
        components: {
        FlipCount
        },
        props: {
            deleteErrorMessage: {
                type: String,
                default: ''
            }
        },
        data () {
        return {
            isOpen: false,
            promoEnds: null,
            bannerType: null,
            debug: false
        }
        },
        computed: {
            bannerLink () {
                return '/subscriptions/manage/?selected=year'
            },
            ...mapGetters({
                currentUser: "main/getCurrentUser"
            })
        },
        created () {
            
        },
        mounted () {
            setTimeout(() => {
                this.isOpen = true
            }, 1000)
        },
        methods: {
          cancelDeleteProfile() {
            DashboardService.cancelDeleteProfile().then((response) => {
              if (response.status === 204) {
                if (this.$route.path.includes('delete')) window.location.href = window.Urls['gekkoDashboard']()
                else window.location.reload()
              }
            }).catch(() => {
              this.$store.commit('setAlert', { title: this.$gettext('Error'), text: this.$gettext('An error occurred while cancelling your account deletion. Please contact support@getgekko.com for assistance.'), variant: 'danger', duration: 4 })
            })
          }
        }
    }
  </script>
  <style lang="scss">
  .dashboard-promo-banner {
    .banner-price-tag {
      position: relative;
      display: inline;
      &:before {
        content: '';
        position: absolute;
        bottom: -3px;
        left: 0;
        width: 0;
        height: 4px;
        background: white;
        transition: width 1s ease-in-out;
        transition-delay: 1s;
      }
    }
    &.open {
      .banner-price-tag {
        &:before {
          width: 100%;
        }
      }
    }
  }
  </style>
  <style scoped lang="scss">
    .dashboard-promo-banner-delete {
        max-height: 120px;
      cursor: auto !important;
      display: flex;
      align-items: center;
      background: linear-gradient(103deg, #b30e0e, #680d0d) !important;
      height: 0px;
      // overflow: hidden;
      overflow: visible;
      transition: height 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      margin-bottom: 0.5rem;
      border-radius: 12px;
      margin-left: 1rem;
      margin-right: 1rem;
  
      .banner-price-tag {
        &:before {
          bottom: -2px;
          height: 2px;
        }
      }
  
      .banner--content {
        &:hover {
          text-decoration: none;
        }
        display: flex; 
        padding: 0.75rem;
        font-weight: 900; 
        flex-direction: column; 
        justify-content: center; 
        width: 100%; 
        // max-width: 80rem; 
        height: 100%; 
  
        @media (min-width: 640px) { 
          padding-left: 1.5rem;
          padding-right: 1.5rem; 
        }
  
        @media (min-width: 1024px) { 
          padding-left: 2rem;
          padding-right: 2rem; 
        }
  
        transition: all 0.5s cubic-bezier(0.750, 0.020, 0.190, 1.290);
        opacity: 0;
        transform: scale(0.9);
        .banner-content-wrap {
          display: flex; 
          flex-wrap: wrap; 
          justify-content: space-between; 
          align-items: center; 
        }
        &__left {
          display: flex; 
          flex-direction: column; 
          align-items: center; 
          justify-content: space-evenly;
          width: 100%; 
  
          @media (min-width: 640px) { 
            flex-direction: row; 
            flex: 1 1 0%; 
            width: 0; 
          }
  
          .promo {
            display: block; 
            color: #ffffff; 
            text-align: center; 
  
            font-size: 17px;
            line-height: 1.4;
            text-align: left;
            font-weight: 100;
            padding: 1rem;
            padding-right: 2rem;
  
            .promo-intro {
              display: block;
              margin-bottom: 1rem;
            }
            .discount-badge {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
  
              border: 1px dashed white;
              box-shadow: 0 0 0 2px #C42F52, rgba(0,0,0,0.2) 0px 15px 35px 0px, rgba(0,0,0,0.12) 0px 5px 15px 0px;
              background: #C42F52;
              color: white;
              border-radius: 8px;
              padding: 0 0.5rem;
              margin: 0 10px;
            }
          }
          .limited-time {
            font-size: 1rem;
            text-transform: uppercase;
            color: white;
          }
        }
        &__right {
          display: flex; 
          margin-top: 0.25rem; 
          flex-shrink: 0; 
          order: 3; 
          justify-content: center; 
          width: 100%; 
  
          @media (min-width: 640px) { 
            margin-top: 0; 
            margin-right: 3rem; 
            order: 2; 
            width: auto; 
          }
          .pre-deadline {
            display: flex; 
            color: #ffffff; 
            font-size: 1.125rem;
            line-height: 1.75rem; 
            text-transform: uppercase; 
          }
          .flip-count {
            display: flex; 
            color: #333; 
            font-size: 0.875rem;
            line-height: 1.25rem; 
            text-align: center; 
            text-transform: uppercase; 
  
            padding: 1rem;
            background: white;
            border-radius: 12px;
  
            .flip-title {
              font-size: 18px;
            }
            .promo-timer {
              color: #333; 
            }
  
            @media (min-width: 640px) { 
              flex-direction: column; 
            }
            .flip-title {
              margin-bottom: 0.5rem; 
            }
          }
        }
      }
      &.open {
        height: auto;
        .banner--content {
          opacity: 1;
          transform: scale(1);
          transition-delay: 0.5s;
        }
      }
      @media (min-width: 640px) {
        &.open {
          height: auto;
        }
      }
      .cancel-deletion-message {
        color: white;
      }
      .cancel-deletion-message:hover {
        text-decoration: underline;
        cursor: pointer;
      }
      
  
    }
  </style>
  